<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Reporte de ascensos</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-btn
                  small
                  text
                  :loading="loadingCsvDetalle"
                  @click="descargarDetallesRangoCSV"
                >
                  Descargar resultados
                  <v-icon right>mdi-microsoft-excel</v-icon>
                </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row no-gutters class="pb-4" style="justify-content: space-between">
            <v-col sm="9" style="align-self: center; display: flex; flex-direction: column">
              <v-row>
                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogIni"
                    v-model="ui.modalIni"
                    :return-value.sync="filtros.fecha_inicio"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filtros.fecha_inicio"
                        dense
                        label="Fecha de inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click="ui.tmpIni = filtros.fecha_inicio"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpIni"
                      scrollable
                      locale="es"
                      :max="filtros.fecha_fin || undefined"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalIni = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogIni.save(ui.tmpIni)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="2" class="d-flex align-end">
                  <v-dialog
                    ref="dialogFin"
                    v-model="ui.modalFin"
                    :return-value.sync="filtros.fecha_fin"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filtros.fecha_fin"
                        dense
                        label="Fecha fin"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        @click="ui.tmpFin = filtros.fecha_fin"
                      />
                    </template>
                    <v-date-picker
                      v-model="ui.tmpFin"
                      :min="filtros.fecha_inicio || undefined"
                      scrollable
                      locale="es"
                    >
                      <v-spacer />
                      <v-btn text @click="ui.modalFin = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogFin.save(ui.tmpFin)">Aceptar</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="4" class="pt-0" style="display: flex; align-items: flex-end">
                  <v-text-field
                    class="pt-0"
                    v-model="searchResumen"
                    onlyRead
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            
            <v-col sm="3" class="text-right" style="margin-top: 21px">
              <v-btn
                small
                outlined
                :loading="loading"
                :disabled="!filtros.fecha_inicio || !filtros.fecha_fin"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="fetchResumen"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="itemsRouteFiltered"
            :loading="loading"
            :search="searchResumen"
            :custom-filter="customFilterResumen"
            :items-per-page="5"
            loading-text="Cargando registros... Por favor espere"
            :footer-props="{
              itemsPerPageText: 'Elementos por página',
              itemsPerPageAllText: 'Todos',
              itemsPerPageOptions: [5,10,25,50,-1]
            }"
          >
            <template v-slot:[`item.fecha`]="{ item }">
              {{ moment.tz(item.fecha, TZ).format('YYYY-MM-DD') }}
            </template>

            <template v-slot:[`item.numero_economico`]="{ item }">
              <span v-for="(u, idx) in item.numero_economico" :key="u">
                {{ u }}<span v-if="idx < item.numero_economico.length - 1">, </span>
              </span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    aria-label="Detalle"
                    :disabled="!item.nombre_planta || !item.fecha"
                    @click="openDetalle(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>No hay información disponible</template>
            <template v-slot:no-results>No se obtuvieron resultados</template>
          </v-data-table>

          <v-dialog v-model="dialogs.detalle" max-width="1200px">
            <v-card class="rounded-xl elevation-3">
              <v-toolbar dense dark color="pinkKonect" elevation="2">
                <v-toolbar-title>
                  Detalle — {{ detalle.nombrePlanta }} ({{ detalle.fecha }})
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  text
                  :loading="loadingDetail"
                  @click="exportarDetalleActualDesdeTabla"
                >
                  Descargar resultados
                  <v-icon right>mdi-microsoft-excel</v-icon>
                </v-btn>
                <v-btn icon @click="dialogs.detalle = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-toolbar>

              <v-card-text>
                 <v-text-field
                    class="pt-0"
                    v-model="searchDetalle"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                <v-data-table
                  :search="searchDetalle"
                  :custom-filter="customFilterDetalle"
                  :headers="headersDetail"
                  :items="itemsDetail"
                  :loading="loadingDetail"
                  dense
                  :items-per-page="10"
                  loading-text="Cargando detalles..."
                  class="mt-3"
                >
                  <template v-slot:[`item.fechaHoraInicio`]="{ item }">
                    {{ formatFecha(item.fechaHoraInicio, 'YYYY-MM-DD HH:mm') }}
                  </template>
                  <template v-slot:[`item.fechaHoraFin`]="{ item }">
                    {{ formatFecha(item.fechaHoraFin, 'YYYY-MM-DD HH:mm') }}
                  </template>

                  <template v-slot:no-data>No hay detalles disponibles</template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import moment from 'moment-timezone'
import _ from 'lodash'
import services from '@/utils/services'
import errorList from '@/utils/errorsList'
import downloadjs from 'downloadjs'
import { tablek, errormsg, simpleDialog, BasicBtn, infoBtn, csvButton, infoChip } from '@/components'
import Papa from 'papaparse' // librería para convertir a CSV

export const TZ = 'America/Monterrey'

function dayISOUTC(day, end = false) {
  return moment.tz(day, 'YYYY-MM-DD', TZ)[end ? 'endOf' : 'startOf']('day')
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss[Z]')
}

function normUnit(v) {
  const s = String(v ?? '').trim()
  const t = s.replace(/^0+/, '')
  return t === '' ? '0' : t
}

export default {
  name: 'AscensosTabs',
  components: { tablek, errormsg, simpleDialog, BasicBtn, infoBtn, csvButton, infoChip },
  data: () => ({
    loading: false,
    loadingReports: false,
    loadingDetail: false,
    success: false,
    msgSuccess: '',
    error: false,
    codeError: '',
    errorList,
    filtros: {
      fecha_inicio: moment().format('YYYY-MM-DD'),
      fecha_fin: moment().format('YYYY-MM-DD'),
      rutaNombre: '',
    },
    routes: [],
    stateIds: [],
    headers: [
      { text: 'Ruta', align: 'center', sortable: false, value: 'nombre_planta' },
      { text: 'Fecha', align: 'center', sortable: false, value: 'fecha' },
      { text: 'Unidades de ruta', align: 'center', sortable: false, value: 'numero_economico' },
      { text: 'Viajes totales del día', align: 'center', sortable: false, value: 'cantidad_viajes' },
      { text: 'Pasajeros totales del día', align: 'center', sortable: false, value: 'pasajeros_totales' },
      { text: 'Acciones', align: 'center', sortable: false, value: 'actions' },
    ],
    items: [],
    searchResumen: '',
    dialogs: { detalle: false },
    detalle: { fecha: null, nombrePlanta: '', nombreRuta: '', numerosEconomicos: [], idViajesResumen: [] },
    headersDetailFixed: [
      { text: 'Folio', value: 'folioViaje', align: 'start' },
      { text: 'Ruta principal',value: 'nombrePlanta', align: 'start'},
      { text: 'Ruta', value: 'nombreRuta', align: 'start' },
      { text: 'Inicio', value: 'fechaHoraInicio', align: 'start' },
      { text: 'Fin', value: 'fechaHoraFin', align: 'start' },
      { text: 'No. Económico', value: 'numeroEconomico', align: 'start' },
      { text: 'Pasajeros totales', value: 'pasajerosMaximos', align: 'end' },
    ],
    headersDetail: [],
    itemsDetail: [],
    itemsDetailRaw: [],
    dynamicStops: [],
    searchDetalle: '',
    ui: { modalIni: false, modalFin: false, tmpIni: null, tmpFin: null },
    moment,
  }),
  computed: {
    itemsRouteFiltered() {
      const q = (this.filtros.rutaNombre || '').toLowerCase().trim()
      if (!q) return this.items
      return this.items.filter(it =>
        String(it?.nombre_planta || '').toLowerCase().includes(q)
      )
    },
    customFilterDetalle() {
      return (_value, search, item) => {
        if (!search) return true;
        const q = String(search).toLowerCase().trim();

        return (
          String(item?.folioViaje || '').toLowerCase().includes(q) ||
          String(item?.nombrePlanta || '').toLowerCase().includes(q) ||
          String(item?.nombreRuta || '').toLowerCase().includes(q) ||
          String(item?.fechaHoraInicio || '').toLowerCase().includes(q) ||
          String(item?.fechaHoraFin || '').toLowerCase().includes(q) ||
          String(item?.numeroEconomico || '').toLowerCase().includes(q)
        );
      };
    },
    customFilterResumen() {
      return (_value, search, item) => {
        if (!search) return true
        const q = String(search).toLowerCase().trim()

        const inRutas = String(item?.nombre_planta || '')
          .toLowerCase()
          .includes(q)

        const inUnits = (item?.numero_economico || [])
          .some(u => String(u || '').toLowerCase().includes(q))

        const inFecha = String(item?.fecha || '')
          .toLowerCase()
          .includes(q)

        return inRutas || inUnits || inFecha
      }
    },
    allRoutesSelected() {
      return this.routes.length > 0 && this.stateIds.length === this.routes.length
    },
    someRoutesSelected() {
      return this.stateIds.length > 0 && !this.allRoutesSelected
    },
    iconRoutes() {
      if (this.allRoutesSelected) return 'mdi-close-box'
      if (this.someRoutesSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  mounted() {
    this.initDates()
    this.fetchRoutes()
    this.fetchResumen()
  },
  methods: {
    initDates() {
      const from = moment().subtract(9, 'months').format('YYYY-MM-DD HH:mm')
      this.allowedDates = from
      this.allowedDates2 = from
    },
    formatFecha(val, mask = 'YYYY-MM-DD HH:mm') {
      if (!val) return '-'
      return moment.tz(val, TZ).format(mask)
    },

    async fetchRoutes() {
      try {
        const clientsResp = await this.axios.get(services.routes.clients)
        const clients = _.uniqWith(_.get(clientsResp, 'data.data', []), _.isEqual)
        const promises = clients.map(c =>
          this.axios.get(`${services.routes.routesByClient}/${c.idcliente_externo}`)
        )
        const results = await Promise.all(promises)
        this.routes = []
        results.forEach(r => { this.routes = this.routes.concat(_.get(r, 'data.data', [])) })
        this.routes.forEach(rt => { rt.name = `${rt.nombre_planta} - ${rt.tipo_servicio}` })
      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error al cargar rutas'))
      }
    },

    toggleRoutes() {
      this.$nextTick(() => {
        this.stateIds = this.allRoutesSelected ? [] : this.routes.map(r => r.idruta_externo)
      })
    },

    async fetchResumen() {
      if (!this.filtros.fecha_inicio || !this.filtros.fecha_fin) { this.items = []; return }
      if (this.filtros.fecha_inicio > this.filtros.fecha_fin) { this.filtros.fecha_fin = this.filtros.fecha_inicio }
      try {
        this.loading = true
        const url = services.routes.resRd
        const payload = {
          data: {
            fecha_inicio: `${this.filtros.fecha_inicio}T00:00:00-06:00`,
            fecha_fin: `${this.filtros.fecha_fin}T23:59:59-06:00`,
            idruta_externos: this.stateIds && this.stateIds.length ? this.stateIds : []
          }
        }
        const { data: resp } = await this.axios.post(url, payload)
        const arr = Array.isArray(_.get(resp, 'data', resp)) ? _.get(resp, 'data', resp) : []
        this.items = arr

      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error'))
      } finally {
        this.loading = false
      }
    },

    openDetalle(row) {
      const planta = String(row?.nombre_planta || '').trim()
      const iso = row?.fecha 
      if (!planta || !iso) return

      const fechaDia = this.moment(iso).format('YYYY-MM-DD')

      this.detalle = {
        fecha: fechaDia,
        nombrePlanta: planta,
        nombreRuta: (row?.nombre_rutas || []).join(', '),
        numerosEconomicos: (Array.isArray(row?.numero_economico) ? row.numero_economico : []).map(normUnit),
        idViajesResumen: Array.isArray(row?.idviajes) ? row.idviajes.map(String) : []
      }

      this.dialogs.detalle = true
      this.fetchDetalle()
    },
    
    async descargarDetallesRangoCSV() {
      try {
        this.loadingReports = true;

        const ini = this.filtros.fecha_inicio;
        const fin = this.filtros.fecha_fin;

        if (!ini || !fin) {
          throw new Error('Selecciona fecha inicio y fin');
        }
        if (ini > fin) {
          throw new Error('La fecha de inicio no puede ser mayor a la fecha fin');
        }

        const plantas = _
          .chain(this.itemsRouteFiltered || this.items || [])
          .map('nombre_planta')
          .filter(Boolean)
          .uniq()
          .value();

        if (!plantas.length) {
          throw new Error('No hay plantas en el resumen para exportar');
        }

        const startUtc = dayISOUTC(ini, false);
        const endUtc   = dayISOUTC(fin, true);

        const url = services.routes.detRd;
        const payload = {
          data: {
            fecha_inicio: startUtc,
            fecha_fin:    endUtc,
            nombre_plantas: plantas,
            csv: true,
          },
        };

        const res = await this.axios.post(url, payload, { responseType: 'blob' });

        const dispo = _.get(res, 'headers.content-disposition', '');
        const match = dispo && dispo.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);

        const fallback = `detalles_${ini}_a_${fin}.csv`;
        const filename = match ? decodeURIComponent(match[1]) : fallback;

        downloadjs(res.data, filename, 'text/csv;charset=utf-8');

      } catch (e) {
        this.error = true;
        this.codeError = _.get(
          e,
          'response.data.message',
          e.message || 'Error al generar CSV de detalles'
        );
      } finally {
        this.loadingReports = false;
      }
    },

    async fetchDetalle() {
      try {
        this.loadingDetail = true
        const url = services.routes.detRd

        const startUtc = dayISOUTC(this.detalle.fecha, false)
        const endUtc   = dayISOUTC(this.detalle.fecha, true)

        const payload = {
          data: {
            fecha_inicio: startUtc,
            fecha_fin:    endUtc,
            nombre_plantas: [this.detalle.nombrePlanta], 
            csv: false,
          }
        }

        const { data: resp } = await this.axios.post(url, payload)

        const arr = Array.isArray(resp?.data) ? resp.data : (Array.isArray(resp) ? resp : [])

        let filtered = arr
        if (this.detalle.numerosEconomicos?.length) {
          const allow = new Set(this.detalle.numerosEconomicos.map(normUnit))
          filtered = arr.filter(v => allow.has(normUnit(v?.numeroEconomico)))
        }

        this.itemsDetailRaw = filtered
        this.rebuildDetalleTable(filtered)

      } catch (e) {
        this.error = true
        this.codeError = _.get(e, 'response.data.message', _.get(e, 'message', 'Error'))
      } finally {
        this.loadingDetail = false
      }
    },
    /*
    async descargarDetallesRangoCSV() {
      try {
        this.loadingReports = true;

        const ini = this.filtros.fecha_inicio;
        const fin = this.filtros.fecha_fin;
        if (!ini || !fin) throw new Error('Selecciona fecha inicio y fin');
        if (ini > fin) throw new Error('La fecha de inicio no puede ser mayor a la fecha fin');

        const plantas = _
          .chain(this.itemsRouteFiltered || this.items || [])
          .map('nombre_planta')
          .filter(Boolean)
          .uniq()
          .value();
        if (!plantas.length) throw new Error('No hay plantas en el resumen para exportar');

        const startUtc = dayISOUTC(ini, false);
        const endUtc   = dayISOUTC(fin, true);

        const url = services.routes.detRd;
        const requests = plantas.map(nombrePlanta =>
          this.axios.post(url, {
            data: {
              fecha_inicio: startUtc,
              fecha_fin:    endUtc,
              nombre_plantas: [nombrePlanta],
              csv: false, 
            }
          }).then(({ data }) => ({
            nombrePlanta,
            viajes: Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : [])
          }))
        );

        const settled = await Promise.allSettled(requests);
        const paquetes = settled
          .filter(r => r.status === 'fulfilled')
          .map(r => r.value);

        const todosViajes = [];
        paquetes.forEach(({ nombrePlanta, viajes }) => {
          viajes.forEach(v => todosViajes.push({ ...v, __planta__: nombrePlanta }));
        });

        const stops = _(todosViajes)
          .flatMap('ascensosPorParada')
          .filter(Boolean)
          .uniqBy(s => `${s.orden}|${s.parada}`)
          .sortBy(['orden', 'parada'])
          .map(s => ({ text: `${s.orden} - ${s.parada}`, value: `parada_${s.orden}` }))
          .value();

        const headers = [
          { text: 'Folio',              value: 'folioViaje' },
          { text: 'Ruta principal',     value: 'nombrePlanta' },
          { text: 'Ruta',               value: 'nombreRuta' },
          { text: 'Inicio',             value: 'fechaHoraInicio' },
          { text: 'Fin',                value: 'fechaHoraFin' },
          { text: 'No. Económico',      value: 'numeroEconomico' },
          { text: 'Pasajeros totales',  value: 'pasajerosMaximos' },
          ...stops,
        ];
        const headerTexts = headers.map(h => h.text);
        const keys        = headers.map(h => h.value);

        const filas = todosViajes.map(v => {
          const base = {
            folioViaje: _.get(v, 'folioViaje', ''),
            nombrePlanta: _.get(v, 'nombrePlanta', _.get(v, 'nombre_planta', v.__planta__ || '')),
            nombreRuta: _.get(v, 'nombreRuta', ''),
            fechaHoraInicio: _.get(v, 'fechaHoraInicio', null),
            fechaHoraFin: _.get(v, 'fechaHoraFin', null),
            numeroEconomico: _.get(v, 'numeroEconomico', ''),
            pasajerosMaximos: 0,
          };
          stops.forEach(c => { base[c.value] = 0; });

          const list = _.get(v, 'ascensosPorParada', []) || [];
          list.forEach(s => {
            const key = `parada_${s.orden}`;
            base[key] = Number(s.cantidad || 0);
            base.pasajerosMaximos += Number(s.cantidad || 0);
          });
          return base;
        });

        const toCsvRow = (arr) =>
          arr.map(val => {
            const s = String(val ?? '').replace(/"/g, '""');
            return /[",\n]/.test(s) ? `"${s}"` : s;
          }).join(',');

        const FECHA_FMT = 'YYYY MM DD HH:mm';

        const csv = [
          toCsvRow(headerTexts),
          ...filas.map(row => toCsvRow(
            keys.map(k => {
              const val = row[k];
              if (k === 'fechaHoraInicio' || k === 'fechaHoraFin') {
                return val ? moment(val).tz(TZ).format(FECHA_FMT) : '';
              }
              return val;
            })
          )),
        ].join('\n');


        downloadjs(
          new Blob([csv], { type: 'text/csv;charset=utf-8' }),
          `detalles_${ini}_a_${fin}.csv`,
          'text/csv;charset=utf-8'
        );

      } catch (e) {
        this.error = true;
        this.codeError = _.get(e, 'response.data.message', e.message || 'Error al generar CSV de detalles');
      } finally {
        this.loadingReports = false;
      }
    },
    */
    toCsvRow(arr) {
      return arr.map(v => {
        const s = String(v ?? '').replace(/"/g, '""')
        return /[",\n]/.test(s) ? `"${s}"` : s
      }).join(',')
    },

    async exportarDetalleActualDesdeTabla() {
      try {
        this.loadingDetail = true

        const headers = this.headersDetail.map(h => h.text)
        const keys    = this.headersDetail.map(h => h.value)

        this.itemsDetail = this.itemsDetail.map(e => ({
          ...e,
          fechaHoraFin: moment(e.fechaHoraFin).tz(TZ).format('YYYY MM DD HH:mm'),
          fechaHoraInicio: moment(e.fechaHoraInicio).tz(TZ).format('YYYY MM DD HH:mm')
        }));


        const rows = (this.itemsDetail || []).map(row => keys.map(k => row[k]))
        const csv  = [this.toCsvRow(headers), ...rows.map(this.toCsvRow)].join('\n')
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })

        const nombre = `detalle_visible_${(this.detalle?.nombrePlanta||'planta')}_${(this.detalle?.fecha||'')}.csv`
        downloadjs(blob, nombre, 'text/csv;charset=utf-8')
      } catch (e) {
        this.error = true
        this.codeError = e.message || 'Error al exportar CSV desde la tabla'
      } finally {
        this.loadingDetail = false
      }
},

    rebuildDetalleTable(data) {
      const stops = _(data)
        .flatMap('ascensosPorParada')
        .filter(Boolean)
        .uniqBy(s => `${s.orden}|${s.parada}`)
        .sortBy(['orden', 'parada'])
        .map(s => ({ text: `${s.orden} - ${s.parada}`, value: `parada_${s.orden}` }))
        .value()

      this.dynamicStops = stops
      this.headersDetail = [...this.headersDetailFixed, ...stops]

      this.itemsDetail = data.map(v => {
        const base = {
          folioViaje: _.get(v, 'folioViaje', ''),
          nombrePlanta: _.get(v, 'nombrePlanta', _.get(v, 'nombre_planta', this.detalle?.nombrePlanta || '')),
          nombreRuta: _.get(v, 'nombreRuta', ''),
          fechaHoraInicio: _.get(v, 'fechaHoraInicio', null),
          fechaHoraFin: _.get(v, 'fechaHoraFin', null),
          numeroEconomico: _.get(v, 'numeroEconomico', ''),
          pasajerosMaximos: 0,
        }
        stops.forEach(c => { base[c.value] = 0 })

        const list = _.get(v, 'ascensosPorParada', []) || []
        list.forEach(s => {
          const key = `parada_${s.orden}`
          base[key] = Number(s.cantidad || 0)
          base.pasajerosMaximos += Number(s.cantidad || 0)
        })
        return base
      })
    },
  },
}
</script>

<style scoped>
.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
  border-left-width: 1;
}
</style>
